import { useId } from "react";

interface CustomFoodCreatorProfileIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export function CustomFoodCreatorProfileIcon({
  size = 36,
  color = "#094327",
  className,
}: CustomFoodCreatorProfileIconProps) {
  const gradientId = useId().replace(/:/g, "");

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 31 36"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <defs>
        <linearGradient id={gradientId} x1="15.529" y1="0" x2="15.529" y2="36" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FAFFFA" stopOpacity="0.2" />
          <stop offset="1" stopColor="#FF3B30" stopOpacity="0.55" />
        </linearGradient>
      </defs>
      <path
        d="M15.5287 14.4C19.7981 14.4 23.2592 11.1764 23.2592 7.2C23.2592 3.22355 19.7981 0 15.5287 0C11.2594 0 7.79834 3.22355 7.79834 7.2C7.79834 11.1764 11.2594 14.4 15.5287 14.4Z"
        fill={color}
      />
      <path
        opacity="0.5"
        d="M30.9895 27.8998C30.9895 32.3733 30.9895 35.9998 15.5287 35.9998C0.0678711 35.9998 0.0678711 32.3733 0.0678711 27.8998C0.0678711 23.4263 6.98991 19.7998 15.5287 19.7998C24.0675 19.7998 30.9895 23.4263 30.9895 27.8998Z"
        fill={color}
      />
      <path
        opacity="0.35"
        d="M15.5287 14.4C19.7981 14.4 23.2592 11.1764 23.2592 7.2C23.2592 3.22355 19.7981 0 15.5287 0C11.2594 0 7.79834 3.22355 7.79834 7.2C7.79834 11.1764 11.2594 14.4 15.5287 14.4Z"
        fill={`url(#${gradientId})`}
      />
      <path
        opacity="0.35"
        d="M30.9895 27.8998C30.9895 32.3733 30.9895 35.9998 15.5287 35.9998C0.0678711 35.9998 0.0678711 32.3733 0.0678711 27.8998C0.0678711 23.4263 6.98991 19.7998 15.5287 19.7998C24.0675 19.7998 30.9895 23.4263 30.9895 27.8998Z"
        fill={`url(#${gradientId})`}
      />
    </svg>
  );
}
